import { Image } from "@chakra-ui/react";
import imgContent from "../../../assets/images/content/bg/content-ethical.png";
import tContent from "../../../assets/images/content/bg/content-tablet-ethical.png";
import mContent from "../../../assets/images/content/bg/content-mobile-ethical.png";

import { styled } from "styled-components";
import { useContext } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";
import { downloadFile } from "../../../components/Util";

const EthicalWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BtnEthical = styled.button`
  width: 300px;
  height: 60px;
  background: #333333;
  color: #ffffff;
  font-size: 18px;
  border-radius: 62px;
  margin: 20px 0 100px;
  &:hover {
    background: #969696;
  }
`;

const Ethical = () => {
  const screen = useContext(ScreenContext).style;
  const contents = {
    pc: imgContent,
    mobile: mContent,
    tablet: tContent,
  };

  return (
    <EthicalWrapper>
      <Image 
        src={contents[screen]} 
        w={"100%"} 
        alt="" 
      />
      <BtnEthical 
        onClick={
          () => {
            downloadFile("files", "윤리경영정책.pdf");
          }
        }
      >
        PDF 다운로드
      </BtnEthical>
    </EthicalWrapper>
  );
};

export default Ethical;